module.exports = __webpack_public_path__ + "static/img/emt_example_payment9.98b86cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emt_example_payment9.jpg
// module id = VM97
// module chunks = 0